import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Award } from '../../../../../../../types/bonus';
import { splitOverflow } from '../../../../../utils/array';

const giverName = (award: Award) => award.giver.first_name;

export const useAwardText = (awards: Award[]) => {
	const { t } = useTranslation('recognition');

	return useMemo(() => {
		const { head, tail, overflowCount } = splitOverflow(awards, {
			max: 2,
			minOverflow: 2,
		});

		const names = head.map(giverName).join(', ');

		return !tail.length
			? t('awards.cta.award_list', {
					count: awards.length,
					names,
					interpolation: { escapeValue: false },
				})
			: t('awards.cta.award_list_with_count', {
					count: overflowCount,
					names,
					total: awards.length,
					interpolation: { escapeValue: false },
				});
	}, [awards, t]);
};
